import React, {useCallback, useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import TierTag from "../../../../common/TierTag";
import {ColumnBox, FlexBox} from "../../../../ui/styled";
import ChampionImageWithLane from "../../../../common/ChampionImageWithLane";
import InfluInfo from "../../../../summoner/Profile/InfluInfo";
import useChampionFunc from "../../../../../common/hooks/useChampionFunc";
import {getRegionServer, multiplyNumber, scoreColor, storePuuIdLocal, threedigits} from "../../../../../function";
import {ImageItem, ImageRune} from "../../../../common";
import UseRuneFunc from "../../../../../common/hooks/useRuneFunc";

const Wrapper = styled.tr`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.color.gray_200};
  height: 52px;
  background-color: ${props => props.theme.color.site_main_color};

  td:not(:last-of-type) {
    cursor: pointer;
  }

`;

const Content = styled.td`
  vertical-align: middle;
  background-color: ${props => props.test && "red"};

  .imgChamp {
    width: 36px;
    height: 36px;
    margin: 0;
  }

  .imgDiv {
    border-radius: 6px;
  }

`;

const TempWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const StartBox = styled.div`
  padding-left: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const IndexText = styled.div`
  font-size: 12px;
  color: ${props => props.theme.color.dark_100};
`


const RegionText = styled.span`
  font-size: 14px;
  text-align: center;
  color: ${props => props.theme.color.dark_100};
  margin: ${props => props.margin || 0};
`;

const LPValueText = styled(RegionText)`
  margin-left: 4px;
`;


const SummonerText = styled(RegionText)`
  text-align: left;
  width: 15ch;
  height: 17px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

const LPText = styled(RegionText)`
  color: ${props => props.theme.color.dark_200};
`;

const RoundImage = styled.div`
  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: black;
    overflow: hidden;
  }
`;

const BorderRadiusImage = styled.div`
  background-color: black;
  overflow: hidden;
  border-radius: 4px;
  margin-left: 9px;

  img {
    height: 26px;
  }
`;


const LaneBox = styled.div`
  margin: 0 5px;
`;


const BuildButton = styled.div`
  cursor: pointer;
  border: 1px solid ${props => props.theme.color.green_100};
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.site_main_color};

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }
`;

const BuildImgDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
`;
const InfluWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const RuneBox = styled.div`
  width: 34px;
  height: 26px;
  position: relative;
`;
const BigRuneBox = styled.div`
  .imgRune {
    width: 26px;
    height: 26px;
    border: 1px solid #3C3C3C;
    border-radius: 100%;
    background-color: #262626;
  }
`;
const AbsoluteRuneBox = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;

  .imgRune {
    width: 16px;
    height: 16px;
    border: 1px solid #3C3C3C;
    border-radius: 100%;
    background-color: #262626;
  }
`;

const ItemBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 15px;
  margin-right: 24px;

  .imgItem {
    width: 26px;
    height: 26px;
    border-radius: 4px;
    margin-left: 5px;
  }
`;
const ShoesBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .imgItem {
    width: 26px;
    height: 26px;
    border-radius: 4px;
  }
`;
const ChampionDetailMasteryTableContent = ({
                                               tag,
                                               champion_id,
                                               tier,
                                               division,
                                               lp,
                                               riot_id_name,
                                               play_rate,
                                               games,
                                               win_rate,
                                               rank,
                                               region,
                                               influStatus,
                                               influTeam,
                                               influName,
                                               lane,
                                               kda, ds, gd15,
                                               item, item2, item3, boots,
                                               rune,
                                               puu_id,
                                               subRune,
                                           }) => {
    const {t} = useTranslation();
    useSelector((state) => state?.gameVersion.version);
    //부모에서 인라인 객체로 넘기면 매 렌더마다 새 참조가 되어 React.memo가 무력해진다.
    const influData = useMemo(() => ({
        status: influStatus,
        team: influTeam,
        name: influName,
    }), [influStatus, influTeam, influName]);
    const {getChampion, getUrlNameByChampion} = useChampionFunc();
    const champion = getChampion(champion_id)
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();
    const runes = useSelector((state) => state.imageStore.runes);
    const {findParentRune} = UseRuneFunc();
    const navigateToBuild = useCallback(() => {
        const champName = getUrlNameByChampion(champion);
        history.push(`/champions/${champName}/build/aram`)
    }, [champion, location.search]);

    const navigateToSummoner = useCallback((e) => {
        e.stopPropagation();
        const serverRegion = getRegionServer(region).toLowerCase();
        // window.open(`/summoner/${serverRegion}/${riot_id_name}-${tag}`)
        storePuuIdLocal(`${riot_id_name}-${tag}`, serverRegion, puu_id,)
    }, [location.search, riot_id_name, tag, region]);


    const navigateToMastery = useCallback((e) => {
        e.stopPropagation();
        const serverRegion = getRegionServer(region).toLowerCase();
        storePuuIdLocal(`${riot_id_name}-${tag}`, serverRegion, puu_id, `mastery?champion=${champion.champion_id}`)
    }, [location.search, riot_id_name, tag, region]);

    return (
        <Wrapper>
            <Content onClick={navigateToBuild}>
                <TempWrapper>
                    <IndexText>{rank}</IndexText>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RegionText>{getRegionServer(region)}</RegionText>
                </TempWrapper>
            </Content>
            <Content>
                <FlexBox>
                    <ChampionImageWithLane
                        champion_id={champion_id}
                        borderRadius={'50%'}
                    />
                    <ColumnBox margin={'0 0 0 8px'} height={'36px'}
                               justifyContent={influData?.status ? 'space-between' : 'center'}>
                        <SummonerText onClick={navigateToSummoner}>{riot_id_name}</SummonerText>
                        {influData?.status ? <InfluWrapper>
                            <InfluInfo
                                textColor={theme.color.background_49}
                                influData={influData}
                            />
                        </InfluWrapper> : null}
                    </ColumnBox>
                </FlexBox>
            </Content>
            <Content>
                <StartBox>
                    <TierTag
                        fontSize={'11px'}
                        padding={'4px 4px'}
                        tier={tier}
                        division={division}
                    />
                    <LPValueText>{threedigits(lp)}<LPText> LP</LPText></LPValueText>
                </StartBox>
            </Content>
            <Content>
                <TempWrapper>
                    <LaneBox>
                        <img src={`images/icon_s_position_${lane.toLowerCase()}.svg`}
                             alt={""}/>
                    </LaneBox>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RuneBox>
                        <BigRuneBox>
                            <ImageRune runeId={rune}/>
                        </BigRuneBox>
                        <AbsoluteRuneBox>
                            <ImageRune runeId={findParentRune(runes, subRune)?.id}/>
                        </AbsoluteRuneBox>
                    </RuneBox>
                    <ItemBox>
                        <ImageItem itemId={item}/>
                        <ImageItem itemId={item2}/>
                        <ImageItem itemId={item3}/>
                    </ItemBox>
                    <ShoesBox>
                        <ImageItem itemId={boots}/>
                    </ShoesBox>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RegionText>{multiplyNumber(play_rate, 100)}<LPText> %</LPText></RegionText>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RegionText>{threedigits(games)}</RegionText>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RegionText>{scoreColor(multiplyNumber(win_rate, 100,))}<LPText> %</LPText></RegionText>
                </TempWrapper>
            </Content>
            <Content>
                <TempWrapper>
                    <RegionText>{kda?.toFixed(2)}</RegionText>
                </TempWrapper>
            </Content>
            {/*<Content>*/}
            {/*    <TempWrapper>*/}
            {/*        <RegionText margin={'0 8px 0 0'}>{gd15 > 0 ? '+' : ""}{gd15}</RegionText>*/}
            {/*    </TempWrapper>*/}
            {/*</Content>*/}
            {/*<Content>*/}
            {/*    <TempWrapper>*/}
            {/*        <RegionText>{multiplyNumber(ds, 100,)}<LPText> %</LPText></RegionText>*/}
            {/*    </TempWrapper>*/}
            {/*</Content>*/}
            <Content>
                <TempWrapper>
                    <BuildButton onClick={navigateToMastery}>
                        <FlexBox>
                            <BuildImgDiv>
                                <img src={`${theme.icon.path}/icon_build_more.svg`} width={16} height={16} alt={""}/>
                            </BuildImgDiv>
                            {t('mastery.buildMore')}
                        </FlexBox>
                    </BuildButton>

                </TempWrapper>
            </Content>
        </Wrapper>
    );
};


//모든 prop이 스칼라라 기본 얕은 비교로 충분하다. 값이 그대로인 행은 다시 렌더하지 않는다.
export default React.memo(ChampionDetailMasteryTableContent);
